import { CopyOutlined } from '@ant-design/icons';
import { Button, Col, Row, Tooltip, Typography } from 'antd';
import React from 'react';

import Title from './Title';

interface CandidateManagerFeedbackProps {
  managerFeedbackLink?: string;
}

const CandidateManagerFeedback: React.FC<CandidateManagerFeedbackProps> = ({
  managerFeedbackLink,
}) => {
  return (
    <>
      <Title title="Relatório do Gestor" />
      <Row gutter={[16, 16]}>
        <Col span={19}>
          <Typography.Text>
            Copie e cole no navegador para visualizar o relatório. Lembrando que o link contém
            informações sensíveis para o candidato, é importante que ele seja compartilhado
            <Typography.Text strong> apenas com o gestor</Typography.Text>.
          </Typography.Text>
        </Col>
        <Col span={5}>
          <Tooltip
            trigger="click"
            getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
            title={
              <>
                <Typography.Text style={{ color: 'white' }}>
                  Link do relatório copiado!
                </Typography.Text>
                <br />
                <Typography.Text style={{ color: 'white' }}>
                  Compartilhe com seu gestor
                </Typography.Text>
              </>
            }
          >
            <Button
              icon={<CopyOutlined />}
              type="link"
              style={{ borderColor: 'lightskyblue' }}
              onClick={async () => {
                await navigator.clipboard.writeText(managerFeedbackLink || '');
              }}
            >
              Copiar
            </Button>
          </Tooltip>
        </Col>
      </Row>
    </>
  );
};

export default CandidateManagerFeedback;
